import { motion } from "framer-motion";
import { EASE, Overline, Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "One accountable relationship",
    body: "Consolidate the vendor stack into a single commercial framework. One contract, one governance model, one team answerable for the whole outcome — not five suppliers pointing at each other.",
  },
  {
    num: "02",
    title: "No handover gap",
    body: "One programme, four handovers removed: your team is hired, your platform is built, your data is instrumented and your proposition reaches market — sequenced by one delivery backbone.",
  },
  {
    num: "03",
    title: "Measured, not reported",
    body: "Every engagement runs against agreed KPIs with a 30-day review cycle. You see outcomes — first submissions inside 36 hours, 92% of hires still in seat at day 90 — not activity decks.",
  },
  {
    num: "04",
    title: "Follow-the-sun, by design",
    body: "Six capability centres across the Americas, EMEA and APAC give 24/5 timezone coverage. Work moves with the sun; the standard stays the same in every centre.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="advantage"
      data-testid="manifesto-section"
      className="scroll-mt-24 border-y border-white/10 bg-surface/40"
    >
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-32">
        <Reveal>
          <Overline>The One Group Advantage</Overline>
          <h2 className="mt-6 max-w-2xl font-heading text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl">
            A manifesto for how enterprise delivery{" "}
            <span className="text-gold">should work.</span>
          </h2>
        </Reveal>

        <div className="mt-16">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              data-testid={`manifesto-chapter-${c.num}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: 0.05 * i, ease: EASE }}
              className="group grid gap-6 border-t border-white/10 py-12 last:border-b md:grid-cols-12 md:gap-10"
            >
              <p className="font-mono text-sm tracking-[0.3em] text-gray-500 transition-colors duration-500 group-hover:text-gold md:col-span-2">
                CH. {c.num}
              </p>
              <h3 className="font-heading text-2xl font-medium tracking-tight text-white sm:text-3xl md:col-span-4">
                {c.title}
              </h3>
              <p className="max-w-xl text-base leading-relaxed text-gray-400 md:col-span-6">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
